
import { defineComponent, onBeforeMount, ref } from "vue";
import * as api from "../api/apt";

interface phoneListProp {
  key: string;
  name: string;
  show: boolean;
  value: Array<string>;
}

interface tabledataProp {
  name: string;
  price: number;
}

interface repairdataProp {
  level: string;
  content: string;
  item: string;
  price: string;
}

export default defineComponent({
  data() {
    return {
      productId: "1",
      image: {
        height: "643px",
        position: "relative",
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url(" +
          require("../assets/images/item.png") +
          ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionY: "30%"
      }
    };
  },

  setup() {
    let tabledata = ref<tabledataProp[] | null>(null);
    let tabledata1 = ref<tabledataProp[] | null>(null);
    let tabledata2 = ref<tabledataProp[] | null>(null);
    let tabledata3 = ref<tabledataProp[] | null>(null);
    let tabledata4 = ref<tabledataProp[] | null>(null);
    let tabledata5 = ref<tabledataProp[] | null>(null)
    let phoneList = ref<phoneListProp[] | null>(null);
    let repairList = ref<repairdataProp[] | null>(null);
    let repairList1 = ref<repairdataProp[] | null>(null);
    let show = ref(false);
    let show1 = ref(false);
    let show2 = ref(false);
    let show3 = ref(false);
    let show4 = ref(false);
    let show5 = ref(false);
    let show6 = ref(false)
    let selectphone = ref("");
    // let getPresetPrice = (pid) => {
    //     api.getReplacementPrice(pid).then((res) => {

    //         let prices = res.data.result.results

    //         tabledata.value = prices

    //     })
    // }
    tabledata.value = [
      {
        name: "主板",
        price: 1232
      },
      {
        name: "前壳组件",
        price: 151
        // price: 629
      },
      {
        name: "后壳组件",
        price: 100
        // price: 189
      },
      {
        name: "主后摄像头64M",
        price: 335
      },
      {
        name: "后摄像头8M",
        price: 123
      },
      {
        name: "后摄像头2M",
        price: 99
      },
      {
        name: "前摄像头16M",
        price: 189
      },
      {
        name: "电池",
        price: 129
      }, {
        name: '外屏维修',
        price: 219
      }
    ];

    tabledata1.value = [
      {
        name: "主板",
        price: 1625
      },
      {
        name: "前壳组件",
        price: 195
        // price: 770  //593
      },
      {
        name: "后壳组件",
        price: 100
        // price: 209
      },
      {
        name: "主后摄像头64M",
        price: 345
      },
      {
        name: "后摄像头8M",
        price: 123
      },
      {
        name: "后摄像头2M",
        price: 101
      },
      {
        name: "前摄像头16M",
        price: 138
      },
      {
        name: "电池",
        price: 129
      },
      {
        name: '外屏维修',
        price: 269
      }
    ];

    tabledata2.value = [
      {
        name: "主板",
        price: 1246
      },
      {
        name: "屏幕组件",
        price: 449
      },
      {
        name: "电池",
        price: 129
      },
      {
        name: "前置摄像头组件",
        price: 120
      },
      {
        name: "后置摄像头组件",
        price: 146
      },
      {
        name: "后壳",
        price: 109
      },
      {
        name: '外屏维修',
        price: 219
      }
    ];

    tabledata3.value = [
      {
        name: "主板",
        price: 1260
      },
      {
        name: "屏幕组件",
        price: 449
      },
      {
        name: "电池",
        price: 181
      },
      {
        name: "前置摄像头组件",
        price: 120
      },
      {
        name: "后置摄像头组件",
        price: 146
      },
      {
        name: "后壳",
        price: 109
      },
      {
        name: '外屏维修',
        price: 219
      }

    ]

    tabledata4.value = [
      {
        name: "主板",
        price: 1249
      },
      {
        name: "前壳组件",
        price: 629
      },
      {
        name: '后壳组件',
        price: 206
      },
      {
        name: '主后摄像头50M',
        price: 239
      },
      {
        name: '后摄像头2M（景深）',
        price: 108
      },
      {
        name: '后摄像头2M（微距）',
        price: 98
      },
      {
        name: '前摄像头16M',
        price: 144
      },
      {
        name: "电池",
        price: 198
      },
    ]

    tabledata5.value = [
      {
        name: "主板",
        price: 1439
      },
      {
        name: "前壳组件",
        price: 629
      },
      {
        name: '后壳组件',
        price: 206
      },
      {
        name: '主后摄像头64M',
        price: 239
      },
      {
        name: '后摄像头8M',
        price: 108
      },
      {
        name: '后摄像头2M',
        price: 98
      },
      {
        name: '前摄像头16M',
        price: 144
      },
      {
        name: "电池",
        price: 198
      },
    ]

    phoneList.value = [
      {
        key: "3",
        show: false,
        name: "NZONE S7 Pro+ 5G （SP300）8+128G全网通",
        value: [
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 优雅黑",
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 月光银",
          "NZONE S7 Pro+ 5G （SP300）8+128G全网通 星空蓝"
        ]
      },

      {
        key: "4",
        show: false,
        name: "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版",
        value: [
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 优雅黑",
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 月光银",
          "NZONE S7 Pro+ 5G （SP300）8+128G移动权益版 星空蓝"
        ]
      },
      {
        key: "1",
        show: false,
        name: "NZONE S7 Pro 5G （SP200）8+128G公开版",
        value: [
          "NZONE S7 Pro 5G （SP200）8+128G公开版 优雅黑",
          "NZONE S7 Pro 5G （SP200）8+128G公开版 金色阳光",
          "NZONE S7 Pro 5G （SP200）8+128G公开版 烟雨青蓝"
        ]
      },

      {
        key: "2",
        show: false,
        name: "NZONE S7 Pro 5G （SP200）8+128G权益版",
        value: [
          "NZONE S7 Pro 5G （SP200）8+128G权益版 优雅黑",
          "NZONE S7 Pro 5G （SP200）8+128G权益版 金色阳光",
          "NZONE S7 Pro 5G （SP200）8+128G权益版 烟雨青蓝"
        ]
      },

      {
        key: "5",
        show: false,
        name: "NZONE S7 （SP100）6+128G公开版",
        value: [
          "NZONE S7 （SP100）6+128G公开版 青山翠",
          "NZONE S7 （SP100）6+128G公开版 月光银",
          "NZONE S7 （SP100）6+128G公开版 优雅黑"
        ]
      },
      {
        key: '6',
        show: false,
        name: 'NZONE S7 （SP100）8+128G公开版',
        value: [
          "NZONE S7 （SP100）8+128G公开版 青山翠",
          "NZONE S7 （SP100）8+128G公开版 月光银",
          "NZONE S7 （SP100）8+128G公开版 优雅黑"
        ]
      },
      {
        key: '7',
        show: false,
        name: 'NZONE 50 Pro（SP210）8+128G全网通',
        value: [
          "NZONE 50 Pro（SP210）8+128G全网通 星海蓝",
          "NZONE 50 Pro（SP210）8+128G全网通 幻夜黑",
          "NZONE 50 Pro（SP210）8+128G全网通 翡冷翠",
          "NZONE 50 Pro（SP210）8+128G全网通 雪域白"
        ]
      },
      {
        key: '8',
        show: false,
        name: 'NZONE 50 Pro（SP210）8+256G全网通',
        value: [
          "NZONE 50 Pro（SP210）8+256G全网通 星海蓝",
          "NZONE 50 Pro（SP210）8+256G全网通 幻夜黑",
          "NZONE 50 Pro（SP210）8+256G全网通 翡冷翠",
          "NZONE 50 Pro（SP210）8+256G全网通 雪域白"
        ]
      }
    ];

    repairList.value = [
      {
        level: "不拆机维修与清洁保养服务",
        content: "简易故障排除",
        item: "不拆机清洁、调整设置、重装系统、恢复出厂设置",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "数据备份",
        item: "咨询/辅助数据备份",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "软件升级",
        item: "软件升级",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "不拆机维修",
        item: "不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等",
        price: "50元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：机械零部件更换",
        item:
          "机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等",
        price: "80元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：接口类器件更换",
        item:
          "接口类：电池连接器、耳机连接器、IO连接器、SIM卡座、存储卡卡座、 网口、电话口、插座等",
        price: "100元"
      },
      {
        level: "拆机简单维修",
        content: "重焊",
        item: "针对因器件虚焊原因导致的故障，采用重焊加焊授权器件的方式修复",
        price: "100元"
      },

      {
        level: "拆机简单维修",
        content: "更换主板",
        item: "更换主板",
        price: "100元"
      }
    ];

    repairList1.value = [
      {
        level: "不拆机维修与清洁保养服务",
        content: "简易故障排除",
        item: "不拆机清洁、调整设置、重装系统、恢复出厂设置",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "数据备份",
        item: "咨询/辅助数据备份",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "软件升级",
        item: "软件升级",
        price: "50元"
      },
      {
        level: "不拆机维修与清洁保养服务",
        content: "不拆机维修",
        item: "不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等",
        price: "50元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：机械零部件更换",
        item:
          "机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等",
        price: "80元"
      },
      {
        level: "拆机简单维修",
        content: "拆机维修：接口类器件更换",
        item:
          "接口类：电池连接器、耳机连接器、IO连接器、SIM卡座、存储卡卡座、 网口、电话口、插座等",
        price: "100元"
      },
      {
        level: "拆机简单维修",
        content: "重焊",
        item: "针对因器件虚焊原因导致的故障，采用重焊加焊授权器件的方式修复",
        price: "100元"
      },

      {
        level: "拆机简单维修",
        content: "更换主板",
        item: "更换主板",
        price: "100元"
      },
      {
        level: '拆机复杂维修',
        content: "维修除主板CPU、FLASH和接口类以外的器件",
        item: "主板器件：电阻、电容、电感、二极管、WIFI芯片、蓝牙芯片等器件",
        price: "150元"
      }
    ];

    onBeforeMount(() => {
      let pid = sessionStorage.getItem("pid");
      // getPresetPrice(pid)
    });

    return {
      phoneList,
      show,
      selectphone,
      show1,
      tabledata,
      show2,
      show3,
      show4,
      show5,
      show6,
      tabledata1,
      tabledata2,
      tabledata3,
      tabledata4,
      tabledata5,
      repairList,
      repairList1
    };
  }
});
